module.exports = {
      id: "check-usage",
      viewBox: "0 0 16 11.7",
      url: __webpack_public_path__ + "img/icons.488ce034.svg#check-usage",
      toString: function () {
        return this.url;
      }
    }